export default "__VITE_ASSET__4rvbOGWo__"